// src/i18n/messages.js
// 정적 UI 문구 사전. 한국어(ko) 값은 원문 그대로, 중국어(zh)는 간체.
// DB/백엔드 유래 값은 여기에 넣지 않는다.
export const messages = {
  ko: {
    "nav.home": "처음으로",
    "nav.back": "이전 메뉴 보기",


    "common.thanks": "감사합니다!",
    "common.yes": "예",
    "common.no": "아니오",
    "common.confirmYes": "네",
    "common.completed": "완료되었습니다.",
    "common.answerUnavailable": "응답을 가져올 수 없습니다.",
    "common.serverError": "⚠️ 서버 연결 오류가 발생했습니다. 관리자에 문의해주세요",
    "chat.maxMessages": "이 대화에서 주고받을 수 있는 메시지 수를 넘었어요. 새 대화로 다시 물어봐 주세요.",
    "chat.sessionGone": "대화가 끝나 새 대화를 열었어요. 다시 물어봐 주세요.",
    "common.micNotFound": "마이크를 찾지 못했습니다. 장치를 확인하거나 권한을 허용해주세요.",
    "common.generating": "답변 생성 중…",
    "common.voiceInput": "음성 입력",
    "common.send": "전송",

    "stt.processing": "음성 인식 중…",
    "stt.badAudio": "음성을 인식할 수 없습니다. 다시 녹음해 주세요.",
    "stt.empty": "음성이 들리지 않았습니다. 조금 더 크게 말씀해 주세요.",
    "stt.rateLimited": "요청이 많아 잠시 후 다시 시도해 주세요.",
    "stt.timeout": "음성 인식이 지연되고 있습니다. 다시 시도해 주세요.",
    "common.maxFilesAlert": "파일은 최대 3개까지 선택할 수 있습니다.",
    "common.selectComplete": "선택 완료",
    "common.deleteFile": "파일 삭제",
    "common.inputPlaceholder": "메시지를 입력하세요...",
    "common.attachFile": "사진 및 파일 첨부",
    "common.closeX": "닫기 ×",

    "header.title": "가람포스텍 AI 지원센터",
    "header.subtitle": "24시간 스마트 고객지원 서비스",
    "header.tagline": "24시간 스마트 고객지원",

    "home.paper.title": "용지 요청",
    "home.paper.desc": "영수증 · 주방 프린터 용지 신청",
    "home.sales.title": "매출내역(부가세참고자료)",
    "home.sales.desc": "기간별 매출 자료 이메일 · 팩스로 받기",
    "home.menu.title": "메뉴 수정 및 추가",
    "home.menu.desc": "가격 변경 · 신메뉴 · 품절 처리",


    "notice.title": "공지사항",
    "notice.desc": "최신 공지 확인",
    "notice.listPrompt": "클릭하여 자세한 내용을 확인하세요.",
    "notice.dismissToday": "오늘 하루 보지 않기",

    "inquiry.title": "문의 하기",
    "inquiry.categoryPrompt": "번호를 입력하거나 클릭하여 카테고리를 선택하세요.",
    "inquiry.categoryOther": "기타",
    "inquiry.salesHistoryTitle": "매출 내역",

    "inquiry.periodTitle": "조회 기간",
    "inquiry.periodPrompt": "매출 내역 조회 기간을 선택해주세요.",
    "inquiry.periodChoose": "조회할 기간을 선택하세요.",
    "inquiry.period.h1": "상반기",
    "inquiry.period.h1.sub": "1월 ~ 6월",
    "inquiry.period.h2": "하반기",
    "inquiry.period.h2.sub": "7월 ~ 12월",
    "inquiry.period.all": "전체",
    "inquiry.period.all.sub": "1월 ~ 12월",
    "inquiry.period.custom": "직접입력",
    "inquiry.period.custom.sub": "기간을 직접 지정",

    "inquiry.collectTitle": "문의 정보 수집",
    "inquiry.bizNumberPrompt": "사업자번호를 입력해주세요.",
    "inquiry.greeting": "안녕하세요! 문의사항을 접수해드리겠습니다. 빠른 처리를 위해 몇 가지 정보를 수집하겠습니다.",
    "inquiry.bizNumberGuide": "첫 번째로, 보안 키패드로 사업자번호를 입력하세요.",
    "inquiry.bizNumberDigits": "(숫자 10자리)",

    "inquiry.contentTitle": "문의 내용",
    "inquiry.contentPrompt": "문의내용을 입력해주세요.",
    "inquiry.contentGuide": "마지막으로, 문의내용을 입력하세요.",
    "inquiry.contentExample": "(예: 카드리더기 오류로 결제가 안됩니다, POS 용지 부족으로 용지 요청드립니다)",

    "inquiry.complete.received": "문의가 접수 되었습니다.",
    "inquiry.complete.infoHeader": "접수 정보:",

    "inquiry.label.bizNumber": "사업자번호",
    "inquiry.label.contact": "연락처",
    "inquiry.label.phone": "전화번호",
    "inquiry.label.address": "주소",
    "inquiry.label.ceo": "대표자",
    "inquiry.label.requestContent": "요청 내용",
    "inquiry.label.editRequestContent": "수정 요청 내용",
    "inquiry.label.receiveMethod": "수신 방법",
    "inquiry.label.attachment": "첨부파일",

    "inquiry.deliveryNotice": "택배마감시간 이후 요청건은 다음날 발송됩니다.",
    "inquiry.menuUpdateNotice": "접수해주신 내용을 확인 후 작업 진행 예정이며, 완료 시 연락 드리겠습니다.",
    "inquiry.menuUpdateComplete": "접수해주신 내용을 확인 후 작업 예정이며, 완료 시 연락 드리겠습니다.",
    "inquiry.receivedNotice1": "귀하의 문의사항이 정상적으로 접수되었습니다.",
    "inquiry.receivedNotice2": "담당자가 확인 후 영업일 기준 1-2일 내에 연락드리겠습니다.",
    "inquiry.urgentNotice": "긴급한 사항인 경우 1588-1234로 직접 연락주시기 바랍니다.",

    "inquiry.storeConfirmTitle": "가맹점 확인",
    "inquiry.storeConfirmDesc": "등록된 가맹점 정보를 확인했습니다.",
    "inquiry.storeConfirmGuide": "위 내용이 맞으면 \"예\", 수정이 필요하면 \"아니오\"를 눌러주세요.",

    "inquiry.authEndTitle": "사업자 인증 종료",
    "inquiry.authEndMessage": "사업자 인증을 종료하셨습니다. 다음 메뉴를 선택해주세요.",
    "inquiry.reRegisterOption": "1. 직접입력하기",
    "inquiry.reRegisterOption.sub": "사업자번호, 상호명, 휴대폰을 직접 입력합니다",
    "inquiry.reInputOption": "2. 사업자번호 다시 입력하기",
    "inquiry.reInputOption.sub": "사업자번호를 다시 입력합니다",
    "inquiry.reInputBubble": "사업자번호 다시 입력하기",
    "inquiry.directInputBubble": "직접입력하기",

    "inquiry.registerCompleteTitle": "등록요청 완료",
    "inquiry.registerCompleteDesc": "등록 요청이 완료되었습니다. 어떤 문의를 진행하시겠습니까?",

    "inquiry.paperDetailPrompt": "자동으로 입력되었습니다. 문의 내용을 입력해주세요.",
    "inquiry.paperDetailInfo1": "사업자 정보가 자동으로 입력되었습니다.",
    "inquiry.paperDetailInfo2": "아래 입력창에 문의 내용을 입력 후 전송해주세요.",

    "inquiry.confirmTitle": "문의 접수 확인",
    "inquiry.confirmDesc": "아래 내용으로 문의를 접수하시겠습니까?",

    "inquiry.receiveMethodTitle": "자료 수신 방법",
    "inquiry.receiveMethodPrompt": "매출자료를 수령하실 팩스번호 또는 이메일 주소를 입력해주세요.",
    "inquiry.receiveMethodGuide": "자료를 받으실 방법을 입력하세요.",
    "inquiry.receiveMethodExample": "(예: 이메일 abc@example.com, 팩스 02-1234-5678)",
    "inquiry.receiveMethodDisclaimer": "※각 카드사/국세청에서 집계한 자료와 상이할 수 있으니 부가세 신고시 단순 참고 자료로만 활용하여 주시기 바랍니다.",
    "inquiry.receiveMethodPrefix": "수신방법: ",

    "inquiry.completePaper": "용지신청이 완료되었습니다. 오후 4시 이전 접수시 당일출고 오후 4시 이후 접수건은 다음날에 출고됩니다.",
    "inquiry.completeReceived": "접수가 완료되었습니다.",

    "inquiry.customPeriodTitle": "기간 직접입력",
    "inquiry.customPeriodPrompt": "시작일과 종료일을 선택해주세요.",
    "inquiry.startDateLabel": "시작일",
    "inquiry.endDateLabel": "종료일",
    "bizform.cancel": "취소",
    "bizform.confirm": "확인",

    "keypad.title": "사업자번호 입력",
    "keypad.subtitle": "보안 키패드",
    "keypad.placeholder": "숫자 10자리를 입력하세요",

    "login.title": "안녕하세요! 가람포스텍 AI 지원센터입니다",
    "login.subtitle": "로그인 후 서비스를 이용하실 수 있습니다.",
    "login.bizLabel": "사업자등록번호",
    "login.bizPlaceholder": "숫자 10자리를 입력하세요",
    "login.pwLabel": "비밀번호",
    "login.pwPlaceholder": "비밀번호 입력",
    "login.pwHint": "초기 비밀번호 : 등록 휴대폰 번호 뒤 4자리",
    "login.submit": "로그인",
    "login.lockNotice": "비밀번호 5회 실패 시 10분간 잠금됩니다.",
    "login.fail": "사업자등록번호 또는 비밀번호를 확인해주세요.",
    "login.locked": "로그인이 잠겼습니다. {min}분 뒤 다시 시도해주세요.",
    "login.unavailable": "일시적으로 로그인할 수 없습니다. 잠시 뒤 다시 시도해주세요.",
    "login.expired": "로그인이 만료되었습니다. 다시 로그인해주세요.",
    "pw.title": "비밀번호를 바꿔주세요",
    "pw.desc": "지금은 초기 비밀번호(휴대폰 번호 뒤 4자리)를 쓰고 있어요. 안전을 위해 새 비밀번호로 바꿔주세요.",
    "pw.new": "새 비밀번호",
    "pw.confirm": "새 비밀번호 확인",
    "pw.placeholder": "4~32자",
    "pw.submit": "바꾸기",
    "pw.later": "나중에",
    "pw.length": "새 비밀번호는 4~32자로 입력해주세요.",
    "pw.mismatch": "새 비밀번호가 서로 다릅니다.",
    "pw.wrongCurrent": "현재 비밀번호가 올바르지 않습니다.",
    "pw.fail": "비밀번호를 바꾸지 못했습니다. 잠시 뒤 다시 시도해주세요.",
    "login.logout": "로그아웃",
  },
  zh: {
    "nav.home": "返回首页",
    "nav.back": "查看上一级菜单",


    "common.thanks": "谢谢！",
    "common.yes": "是",
    "common.no": "否",
    "common.confirmYes": "是",
    "common.completed": "已完成。",
    "common.answerUnavailable": "无法获取回复。",
    "common.serverError": "⚠️ 服务器连接出错。请联系管理员",
    "chat.maxMessages": "本次对话的消息数量已达上限，请在新对话中重新提问。",
    "chat.sessionGone": "对话已结束，已为您开启新对话，请重新提问。",
    "common.micNotFound": "未找到麦克风。请检查设备或允许权限。",
    "common.generating": "正在生成回复…",
    "common.voiceInput": "语音输入",
    "common.send": "发送",

    "stt.processing": "正在识别语音…",
    "stt.badAudio": "无法识别语音，请重新录音。",
    "stt.empty": "没有听到语音，请说得大声一些。",
    "stt.rateLimited": "请求过多，请稍后再试。",
    "stt.timeout": "语音识别超时，请重试。",
    "common.maxFilesAlert": "最多只能选择3个文件。",
    "common.selectComplete": "选择完成",
    "common.deleteFile": "删除文件",
    "common.inputPlaceholder": "请输入消息...",
    "common.attachFile": "添加照片和文件",
    "common.closeX": "关闭 ×",

    "header.title": "Garam Postech AI 支持中心",
    "header.subtitle": "24小时智能客户支持服务",
    "header.tagline": "24小时智能客户支持",

    "home.paper.title": "纸张申请",
    "home.paper.desc": "收据纸 · 厨房打印机纸",
    "home.sales.title": "销售明细（增值税参考资料）",
    "home.sales.desc": "按期间通过邮件 · 传真接收销售资料",
    "home.menu.title": "菜单修改及新增",
    "home.menu.desc": "价格 · 新菜 · 售罄",


    "notice.title": "公告",
    "notice.desc": "查看最新公告",
    "notice.listPrompt": "请点击查看详细内容。",
    "notice.dismissToday": "今日内不再显示",

    "inquiry.title": "咨询",
    "inquiry.categoryPrompt": "请输入编号或点击选择分类。",
    "inquiry.categoryOther": "其他",
    "inquiry.salesHistoryTitle": "销售明细",

    "inquiry.periodTitle": "查询期间",
    "inquiry.periodPrompt": "请选择销售明细的查询期间。",
    "inquiry.periodChoose": "请选择要查询的期间。",
    "inquiry.period.h1": "上半年",
    "inquiry.period.h1.sub": "1月~6月",
    "inquiry.period.h2": "下半年",
    "inquiry.period.h2.sub": "7月~12月",
    "inquiry.period.all": "全部",
    "inquiry.period.all.sub": "1月~12月",
    "inquiry.period.custom": "自定义输入",
    "inquiry.period.custom.sub": "直接指定期间",

    "inquiry.collectTitle": "咨询信息收集",
    "inquiry.bizNumberPrompt": "请输入营业执照号码。",
    "inquiry.greeting": "您好！我们将为您受理咨询事项。为了快速处理，我们将收集一些信息。",
    "inquiry.bizNumberGuide": "首先，请使用安全键盘输入营业执照号码。",
    "inquiry.bizNumberDigits": "（10位数字）",

    "inquiry.contentTitle": "咨询内容",
    "inquiry.contentPrompt": "请输入咨询内容。",
    "inquiry.contentGuide": "最后，请输入咨询内容。",
    "inquiry.contentExample": "（例：读卡器故障导致无法结账，POS纸张不足需要申请用纸）",

    "inquiry.complete.received": "您的咨询已受理。",
    "inquiry.complete.infoHeader": "受理信息：",

    "inquiry.label.bizNumber": "营业执照号码",
    "inquiry.label.contact": "联系方式",
    "inquiry.label.phone": "电话号码",
    "inquiry.label.address": "地址",
    "inquiry.label.ceo": "法定代表人",
    "inquiry.label.requestContent": "申请内容",
    "inquiry.label.editRequestContent": "修改申请内容",
    "inquiry.label.receiveMethod": "接收方式",
    "inquiry.label.attachment": "附件",

    "inquiry.deliveryNotice": "快递截止时间之后申请的订单将于次日发货。",
    "inquiry.menuUpdateNotice": "我们将确认您提交的内容后进行处理，完成后会与您联系。",
    "inquiry.menuUpdateComplete": "我们将确认您提交的内容后安排处理，完成后会与您联系。",
    "inquiry.receivedNotice1": "您的咨询已成功受理。",
    "inquiry.receivedNotice2": "负责人确认后将在1-2个工作日内与您联系。",
    "inquiry.urgentNotice": "紧急事项请直接致电1588-1234联系我们。",

    "inquiry.storeConfirmTitle": "加盟店确认",
    "inquiry.storeConfirmDesc": "已查询到登记的加盟店信息。",
    "inquiry.storeConfirmGuide": "如以上内容无误请按\"是\"，如需修改请按\"否\"。",

    "inquiry.authEndTitle": "营业执照认证结束",
    "inquiry.authEndMessage": "您已结束营业执照认证。请选择以下菜单。",
    "inquiry.reRegisterOption": "1. 直接输入",
    "inquiry.reRegisterOption.sub": "直接输入营业执照号码、商号名称、手机号码",
    "inquiry.reInputOption": "2. 重新输入营业执照号码",
    "inquiry.reInputOption.sub": "重新输入营业执照号码",
    "inquiry.reInputBubble": "重新输入营业执照号码",
    "inquiry.directInputBubble": "直接输入",

    "inquiry.registerCompleteTitle": "登记申请完成",
    "inquiry.registerCompleteDesc": "登记申请已完成。您想进行哪项咨询？",

    "inquiry.paperDetailPrompt": "已自动填写。请输入咨询内容。",
    "inquiry.paperDetailInfo1": "已自动填写营业执照信息。",
    "inquiry.paperDetailInfo2": "请在下方输入框中输入咨询内容后发送。",

    "inquiry.confirmTitle": "咨询受理确认",
    "inquiry.confirmDesc": "是否以以下内容提交咨询？",

    "inquiry.receiveMethodTitle": "资料接收方式",
    "inquiry.receiveMethodPrompt": "请输入接收销售资料的传真号码或电子邮箱地址。",
    "inquiry.receiveMethodGuide": "请输入接收资料的方式。",
    "inquiry.receiveMethodExample": "（例：邮箱 abc@example.com，传真 02-1234-5678）",
    "inquiry.receiveMethodDisclaimer": "※本资料可能与各信用卡公司/国税厅统计的资料存在差异，申报增值税时请仅作参考资料使用。",
    "inquiry.receiveMethodPrefix": "接收方式：",

    "inquiry.completePaper": "纸张申请已完成。下午4点前提交将于当天发货，下午4点后提交的订单将于次日发货。",
    "inquiry.completeReceived": "已受理完成。",

    "inquiry.customPeriodTitle": "直接输入期间",
    "inquiry.customPeriodPrompt": "请选择开始日期和结束日期。",
    "inquiry.startDateLabel": "开始日期",
    "inquiry.endDateLabel": "结束日期",
    "bizform.cancel": "取消",
    "bizform.confirm": "确认",

    "keypad.title": "输入营业执照号码",
    "keypad.subtitle": "安全键盘",
    "keypad.placeholder": "请输入10位数字",

    "login.title": "您好！这里是 Garam Postech AI 支持中心",
    "login.subtitle": "登录后即可使用服务。",
    "login.bizLabel": "营业执照号码",
    "login.bizPlaceholder": "请输入10位数字",
    "login.pwLabel": "密码",
    "login.pwPlaceholder": "请输入密码",
    "login.pwHint": "初始密码 : 登记手机号码后4位",
    "login.submit": "登录",
    "login.lockNotice": "密码连续错误5次将锁定10分钟。",
    "login.fail": "请确认营业执照号码或密码。",
    "login.locked": "登录已锁定，请{min}分钟后再试。",
    "login.unavailable": "暂时无法登录，请稍后再试。",
    "login.expired": "登录已过期，请重新登录。",
    "pw.title": "请修改密码",
    "pw.desc": "您正在使用初始密码（手机号码后4位）。为了安全，请设置新密码。",
    "pw.new": "新密码",
    "pw.confirm": "确认新密码",
    "pw.placeholder": "4~32个字符",
    "pw.submit": "修改",
    "pw.later": "以后再说",
    "pw.length": "新密码请输入4~32个字符。",
    "pw.mismatch": "两次输入的新密码不一致。",
    "pw.wrongCurrent": "当前密码不正确。",
    "pw.fail": "密码修改失败，请稍后再试。",
    "login.logout": "退出登录",
  },
};
